// Icono SVG Flaticon menú hamburguesa https://www.flaticon.es/icono-gratis/menu_12786866
export const AdminMenuIcon = (
  <svg width="28" height="28" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    <g id="SVGRepo_iconCarrier">
      <rect x="8" y="16" width="48" height="6" rx="3" fill="currentColor"/>
      <rect x="8" y="29" width="48" height="6" rx="3" fill="currentColor"/>
      <rect x="8" y="42" width="48" height="6" rx="3" fill="currentColor"/>
    </g>
  </svg>
);
